import {forwardRef} from "react";
import {t} from "i18next";

const DrawIndexBreadcrumb = forwardRef((props:{arrayBreadcrumb:any,marginLeft?:any,onAction:any}, ref)=>{
    return(
        <div className={'flex-row-vertical-center ml-16'} style={{fontSize:'13px',marginLeft:props.marginLeft || '16px',width:(props.arrayBreadcrumb?.length > 0)?'calc(100% - 80px)':'auto'}}>
            {
                props.arrayBreadcrumb.map(p=>{
                    if (p == props.arrayBreadcrumb[props.arrayBreadcrumb.length - 1]){
                        return <span className={'font-family-medium span-single-line'}>{p.title || t("Untitled")}</span>
                    }
                    return <><span className={'font-family-medium cursor-pointer'} style={{fontSize:'13px',flexShrink:'0'}} onClick={()=>{
                        props.onAction(p);
                    }}>{p.title}</span><span style={{margin:'0 6px'}}>/</span></>
                })
            }
        </div>
    )
});

export default DrawIndexBreadcrumb;